import playerFactory from './player.factory';
export default playerFactory;
